const HomeworksDetails = () => import('../views/Main/HomeworksDetails.vue');

export default {
  path: '/dziecko/prace-domowe/zadanie/:id',
  name: 'Main.HomeworksDetails',
  component: HomeworksDetails,
  meta: {
    background: 'blue-light-main',
  },
};
